function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 1a.5.5 0 01.09.992L11.5 2H11v4h1a3 3 0 012.995 2.824L15 9V4h-.5a.5.5 0 01-.09-.992L14.5 3h6a.5.5 0 01.09.992L20.5 4H20v6a3 3 0 012.995 2.824L23 13v6a3 3 0 01-2.824 2.995L20 22c0 .552-.336 1-.75 1s-.75-.448-.75-1h-2c0 .552-.336 1-.75 1s-.75-.448-.75-1c-.547 0-1.06-.146-1.5-.402-.379.22-.809.358-1.268.393L12 22c0 .566-.448 1.025-1 1.025s-1-.459-1-1.025H6a1 1 0 11-2 0 3 3 0 01-2.995-2.824L1 19V9a3 3 0 012.824-2.995L4 6h1V2h-.5a.5.5 0 01-.09-.992L4.5 1h7zM6 6h4V2H6v4zm10 4h3V4h-3v6zm-1 1h5a2 2 0 012 2v6l-.006.15A2 2 0 0120 21h-5l-.174-.007a1.967 1.967 0 01-.492-.107A2.988 2.988 0 0015 19v-8zm2 1.5a.5.5 0 01.492.41l.008.09v6a.5.5 0 01-.992.09L16.5 19v-6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.492.41L20 13v6a.5.5 0 01-.992.09L19 19v-6a.5.5 0 01.5-.5zM14 9a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V9zm-9.992.41a.5.5 0 01.984 0L5 9.5V19l-.008.09a.5.5 0 01-.984 0L4 19V9.5l.008-.09zm3.5 0a.5.5 0 01.984 0l.008.09V19l-.008.09a.5.5 0 01-.984 0L7.5 19V9.5l.008-.09zm3.5 0a.5.5 0 01.984 0L12 9.5V19l-.008.09a.5.5 0 01-.984 0L11 19V9.5l.008-.09z"
  }));
};
const SvgPackagesBrand = styled(BaseComponent).withConfig({
  displayName: "PackagesBrand__SvgPackagesBrand",
  componentId: "sc-tx8eun-0"
})(["outline:none;"]);
SvgPackagesBrand.isIcon = true;
export default SvgPackagesBrand;